import { render, staticRenderFns } from "./Crop2ML_Platforms.vue?vue&type=template&id=2a775f87&scoped=true"
import script from "./Crop2ML_Platforms.vue?vue&type=script&lang=js"
export * from "./Crop2ML_Platforms.vue?vue&type=script&lang=js"
import style0 from "./Crop2ML_Platforms.vue?vue&type=style&index=0&id=2a775f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a775f87",
  null
  
)

export default component.exports